import { BaseCamelCasedResource } from "./BasePlainResource";
import { legacyApiResourceUrl } from "@ploy-lib/core";
export var SignerType;
(function (SignerType) {
    SignerType[SignerType["BusinessSigner"] = 0] = "BusinessSigner";
    SignerType[SignerType["PrivateSigner"] = 1] = "PrivateSigner";
    SignerType[SignerType["PrivateCosigner"] = 2] = "PrivateCosigner";
    SignerType[SignerType["VendorSigner"] = 3] = "VendorSigner";
    SignerType[SignerType["GuarantorSigner"] = 4] = "GuarantorSigner";
    SignerType[SignerType["SupplierSigner"] = 5] = "SupplierSigner";
    SignerType[SignerType["OtherResidualValueGuarantor"] = 6] = "OtherResidualValueGuarantor";
})(SignerType || (SignerType = {}));
export class ApplicationSignerResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.documents = [];
        this.mustSign = false;
        this.name = "";
        this.firstName = "";
        this.lastName = "";
        this.birthDate = "";
        this.ssn = "";
        this.role = "";
        this.phone = "";
        this.email = "";
        this.ssnAddedByInternal = false;
        this.isVendorSigner = false;
        this.reference = "";
        this.copiedFromCustomer = false;
        this.signerType = SignerType.BusinessSigner;
        this.ssnIsHidden = false;
        this.validToDate = "";
        this.lockPersonalInfo = false;
        this.lockContactInfo = false;
        this.canSetMustSign = true;
    }
    pk() {
        return this.applicationSignerId?.toString();
    }
    static async fetch(input, init) {
        const jsonResponse = await super.fetch(input, init);
        let { signer, errorMessage, success } = jsonResponse || {};
        const actualResponse = signer ? signer : jsonResponse;
        if (errorMessage || success === false)
            throw new Error(errorMessage);
        return actualResponse;
    }
    static list() {
        return super.list().extend({
            schema: [this],
            url: (params) => {
                const applicationSignersUrl = legacyApiResourceUrl("/Signer/GetSignersForApplication/");
                const url = this.listUrl(params);
                return url.replace(this.urlRoot, applicationSignersUrl);
            }
        });
    }
    static ssnCreate() {
        return this.create().extend({
            url: (params) => this.listUrl(params).replace(this.urlRoot, legacyApiResourceUrl("Signer/GetCustomerSsn"))
        });
    }
    static ssnUpdate() {
        return this.update().extend({
            url: (params) => this.listUrl(params).replace(this.urlRoot, legacyApiResourceUrl("Signer/GetCustomerSsn"))
        });
    }
}
ApplicationSignerResource.urlRoot = legacyApiResourceUrl("Signer/SaveApplicationSigner");
//# sourceMappingURL=ApplicationSignerResource.js.map